var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoOrderTracker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 25",
    style: {
      enableBackground: "new 0 0 24 25"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M6,23.1c1.8,1,3.9,1.6,6,1.6c6.6,0,11.9-5.4,11.9-12.1s-5.4-12.1-12-12.1c-0.6,0-1,0.4-1,1s0.4,1,1,1 c5.5,0,9.9,4.4,9.9,10c0,5.5-4.5,10.1-9.9,10.1c-1.8,0-3.5-0.4-5-1.3c-0.5-0.2-1.1-0.1-1.4,0.4C5.4,22.2,5.5,22.8,6,23.1z M6.4,2 C5.9,2,5.5,2.4,5.5,2.9s0.4,0.9,0.9,0.9s0.9-0.4,0.9-0.9S6.9,2,6.4,2z M1.5,7c0-0.5,0.4-0.9,0.9-0.9S3.3,6.5,3.3,7S2.9,7.9,2.4,7.9 S1.5,7.5,1.5,7z M0.9,11.7c-0.5,0-0.9,0.4-0.9,0.9s0.4,0.9,0.9,0.9s0.9-0.4,0.9-0.9C1.7,12.1,1.3,11.7,0.9,11.7z M1.5,18.3 c0-0.5,0.4-0.9,0.9-0.9s0.9,0.4,0.9,0.9s-0.4,0.9-0.9,0.9S1.5,18.8,1.5,18.3z M14.6,9.1H9.2L8.6,13l0,0h6.6L14.6,9.1z M16.3,8.9 l0.6,3.9c0.1,0.5-0.1,1-0.4,1.4c-0.1,0.1-0.2,0.2-0.3,0.3l0,0V17c0,0.5-0.4,0.9-0.9,0.9s-0.9-0.4-0.9-0.9v-2.2H9.3V17 c0,0.5-0.4,0.9-0.9,0.9S7.5,17.5,7.5,17v-2.5l0,0c-0.1-0.1-0.2-0.2-0.3-0.3c-0.3-0.4-0.5-0.9-0.4-1.4l0.6-3.9c0.3-0.9,1-1.5,1.8-1.5 h5.4C15.5,7.4,16.2,8,16.3,8.9z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoOrderTracker);
export default __webpack_public_path__ + "static/media/ico-order-tracker.a27e2476e1a4926f3bf3aa4040e1cf2c.svg";
export { ForwardRef as ReactComponent };